var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "03-Appointment-expand",
    transform: "translate(-491.000000, -308.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-15",
    transform: "translate(225.000000, 147.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-24",
    transform: "translate(20.000000, 161.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-19",
    transform: "translate(246.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#1DB4CF",
    x: 0,
    y: 0,
    width: 40,
    height: 40,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4028291,27.774103 C24.7687461,29.1867255 22.5826087,30 20,30 C16.0888889,30 12.7222222,27.7555556 11.0777778,24.4888889 L11.0777778,24.4888889 L14.3111111,21.9777778 C15.1111111,24.3888889 17.3555556,26.1333333 20,26.1333333 C21.4888889,26.1333333 22.6222222,25.7222222 23.4666667,25.1333333 L23.4666667,25.1333333 L23.6943981,24.9640862 C24.8688966,24.0382161 25.4065359,22.7568627 25.5111111,21.8888889 L25.5111111,21.8888889 L20,21.8888889 L20,18.1777778 L29.3888889,18.1777778 C29.5333333,18.8 29.6,19.4 29.6,20.2222222 C29.6,23.2666667 28.5111111,25.8333333 26.6222222,27.5777778 L26.6222222,27.5777778 Z M11.0666667,15.5111111 L14.3,18.0222222 C14.1,18.6444444 13.9777778,19.3111111 13.9777778,20 C13.9777778,20.6888889 14.1,21.3555556 14.3111111,21.9777778 L14.3111111,21.9777778 L11.0666667,24.4888889 C10.3888889,23.1333333 10,21.6111111 10,20 C10,18.3888889 10.3888889,16.8666667 11.0666667,15.5111111 L11.0666667,15.5111111 Z M20,10 C22.7,10 24.9555556,10.9888889 26.6888889,12.6 L26.6888889,12.6 L23.8666667,15.3555556 C23.1444444,14.6777778 21.8777778,13.8666667 20,13.8666667 C17.3555556,13.8666667 15.1111111,15.6111111 14.3,18.0222222 L14.3,18.0222222 L11.0666667,15.5111111 C12.7111111,12.2444444 16.0888889,10 20,10 Z",
    id: "Combined-Shape",
    fill: "#FFFFFF"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcGoogle);
export default __webpack_public_path__ + "static/media/icGoogle.34b7d025bf816bce29d2c945aa376ce2.svg";
export { ForwardRef as ReactComponent };